import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Accordion/Accordion.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Accordion/Accordion.ts';

export const prototypeName = 'VnrjP3dOZzhDndLPjyZ0i3evvx9NWaUobNpNoPAls2pwPv0v8MhPR5RO230RuOlVGxdQeqiRlkZA';
export {styles};
export {script};